import React, { Component } from "react";
import TwoColumns from "../TwoColumns/TwoColumns";
import Button from "../Button/Button";
import Input from "../Input/Input";
import _ from 'lodash';
import "./AwardItem.css";

class AwardItem extends Component {
	state = {
		name: this.props.award.name || "",
		video: this.props.award.video || ""
	};
	handleInputEvent = (e, key) => {
		this.setState({
			[key]: e.target.value
		});
	};
	handleUpdate = () => {
		this.props.handleUpdate({ name: this.state.name, video: this.state.video });
	};
	render() {
		const { name, video } = this.state;
		
		const videoOptions = {};
		_.each(this.props.videoOptions, (video, videoId) => {
			videoOptions[videoId] = video.title;
		});
		if (this.props.expanded) {
			return (
				<div className="admin-award">
				<TwoColumns
				left={
					<div>
					<Input
					title="Award Name"
					value={name}
					onChange={e => this.handleInputEvent(e, "name")}
					/>
					</div>
				}
				right={
					<Input
					title="Awarded To"
					value={video}
					type="dropdown"
					options={{
						"": "Select One",
						...videoOptions
					}}
					onChange={e => this.handleInputEvent(e, "video")}
					/>
				}
				/>
				<Button onClick={this.handleUpdate}>Save</Button>
				</div>
			);
		}
		
		const selectedVideo =
		this.props.award.video &&
		this.props.videoOptions[this.props.award.video] &&
		this.props.videoOptions[this.props.award.video].title;
		
		return (
			<div className="admin-award">
			<div className="description">
				<h4 className="name">{this.props.award.name}</h4>
				{selectedVideo && <h3>{selectedVideo}</h3>}
				{!selectedVideo && <h3 className="-not-awarded">Not Awarded</h3>}
			</div>
			<div className="actions">
				<a href="/" onClick={this.props.setExpanded}>
				Edit
				</a>{" "}
				<a href="/" onClick={this.props.removeSelf}>
				Remove
				</a>
			</div>
			</div>
		);
	}
}

export default AwardItem;



// WEBPACK FOOTER //
// ./src/components/AwardItem/AwardItem.js